type Child = Node | string | null | false | undefined;
type Props = Record<
	string,
	string | boolean | ( ( e: Event ) => void ) | null | undefined
>;

export const h = < K extends keyof HTMLElementTagNameMap >(
	tag: K,
	props: Props = {},
	...kids: Child[]
): HTMLElementTagNameMap[ K ] => {
	const el = document.createElement( tag );
	for ( const [ name, value ] of Object.entries( props ) ) {
		if ( typeof value === 'function' ) {
			el.addEventListener( name.slice( 2 ), value );
		} else if ( value === true ) {
			el.setAttribute( name, '' );
		} else if ( value !== false && value !== null && value !== undefined ) {
			el.setAttribute( name, value );
		}
	}
	for ( const kid of kids ) {
		if ( kid ) {
			el.append( kid );
		}
	}
	return el;
};
